import { render } from "@/components/pages/individualWorkSupport/requirement172/Requirement172.html?vue&type=template&id=6a3f70cf&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement172/Requirement172.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement172/Requirement172.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement172/Requirement172.scss?vue&type=style&index=0&id=6a3f70cf&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3f70cf"]])

export default __exports__